module.exports = __webpack_public_path__ + "static/img/image_sangd.2a762e88.png";